/*
 * @Author: wangyinhu wangyinhude@163.com
 * @Date: 2023-09-20 16:45:09
 * @LastEditors: wangyinhu wangyinhude@163.com
 * @LastEditTime: 2024-03-07 14:07:01
 * @FilePath: \汇学堂Saas-企业中心pc\hxt-saas-pc\src\utils\axios.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios';
import router from '../router/index'
class HttpRequest {
    constructor(baseUrl, timeout = 0) {
        this.baseUrl = baseUrl;
        this.timeout = timeout;
        this.queue = {};
    }
    getInsideConfig() {
        const config = {
            baseURL: this.baseUrl,
            timeout: this.timeout,
            headers: {

            }
        };
        return config;
    }
    destroy(url) {
        delete this.queue[url];
    }
    interceptors(instance, url) {
        // 请求拦截
        instance.interceptors.request.use(
            config => {
                // 添加全局的loading...
                this.queue[url] = true;
                return config;
            },
            error => {

                return Promise.reject(error);
            }
        );
        // 响应拦截
        instance.interceptors.response.use(
            res => {
                // console.log(res);
                // if (res.data.result == '401') {
                // } else {
                //     this.destroy(url);
                //     return res.data;
                // }
                if (res.data.code === 50001 || res.data.result == '401' || res.data.code === 50000) {
                    // this.$message.error(res.data.msg);
                    // this.destroy(url);
                    console.log('50001', '退出登录了', res.data.msg);
                    window.localStorage.clear();

                    router.push('/')

                } else {
                    this.destroy(url);
                    return res.data;
                }
                // const { data, status } = res;
                // return { data, status };
            },
            error => {

                this.destroy(url);
                let errorInfo = error.response;
                if (!errorInfo) {
                    const {
                        request: { statusText, status },
                        config
                    } = JSON.parse(JSON.stringify(error));
                    errorInfo = {
                        statusText,
                        status,
                        request: { responseURL: config.url }
                    };
                }
                return Promise.reject(error);
            }
        );
    }
    request(options) {
        const instance = axios.create();
        options = Object.assign(this.getInsideConfig(), options);
        this.interceptors(instance, options.url);
        return instance(options);
    }
    get(url, data = {}, header = {}, options = {}) {

        options.url = url;
        options.params = data;
        options.headers = { ...header, DeviceType: 'pc', TopDeptId: localStorage.getItem('TopDeptId') ? localStorage.getItem('TopDeptId') : "" };
        options.method = 'GET';
        return this.request(options);
    }
    post(url, data = {}, header = {}, options = {}) {

        options.url = url;
        // data = qs.stringify(data);
        options.data = data;
        options.method = 'POST';
        options.headers = { ...header, DeviceType: 'pc', TopDeptId: localStorage.getItem('TopDeptId') ? localStorage.getItem('TopDeptId') : "" };
        return this.request(options);
    }
}
export default HttpRequest;